import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { ToggleButtonReuseTwo, ToggleButtonWithYesNo } from "../../../AllButton/ToggleButtonReuse";

import Alert from "react-s-alert";
import { Button, Image } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { update_new_subscription_for_vendor } from "../../../../../../../store/actions/authAction";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import isEmpty from "../../../../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import Media from "react-media";
import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import store from "../../../../../../../store/store";
import { UPDATE_SUBSCRIPTION_TYPE } from "../../../../../../../store/types";
import MassCompletion from "../MassCompletion";
import LeftSideNavigation from "../../../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../../../../superAdminComponents/superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import RightSideNavigation from "../../../../../../vendorDashboardComponents/navigationSection/RightSideNavigation";
import { Col, Row } from "react-bootstrap";

export const ExperienceManagementScreen = (props) => {
  const [disabled, setDisable] = useState(
    props &&
      props?.history &&
      props?.history?.location &&
      props?.history?.location?.state &&
      props?.history?.location?.state?.access === "View"
      ? true
      : false
  );
  const history = useHistory();
  const [state, setState] = useState({
    casualDiningOfflineExperience: false,
    casualDiningOnlineExperience: false,
    massCompletion: false,
    massCompletionTime: "",
    taxes: false
  });

  const onClickCasualOfflineExperience = (e) => {
    if (state.casualDiningOfflineExperience === true && !e) {
      setState({
        ...state,
        casualDiningOfflineExperience: !state.casualDiningOfflineExperience,
      });
    } else {
      console.log(e);
      history.push({
        pathname: `${history.location.pathname.includes("multi-service")
          ? "/multi-service"
          : history.location.pathname.includes("fastfood")
            ? "/fastfood"
            : "/casual-fine-dining"
          }/experience-management/offline`,
        state: { access: e },
      });
    }
  };

  const onClickCasualOnlineEexperience = (e) => {
    if (state.casualDiningOnlineExperience === true && !e) {
      setState({
        ...state,
        casualDiningOnlineExperience: !state.casualDiningOnlineExperience,
      });
    } else {
      history.push({
        pathname: `${history.location.pathname.includes("multi-service")
          ? "/multi-service"
          : history.location.pathname.includes("fastfood")
            ? "/fastfood"
            : "/casual-fine-dining"
          }/experience-management/online`,
        state: { access: e },
      });
    }
  };

  const onExpTaxes = () => {
    setState({ ...state, taxes: !state.taxes });
  }

  const onClickRedirectToOtherScreen = () => {
    history.push({
      pathname: "/edit-experience-taxes",
      state: { access: "edit" },
    });
  };

  const onSuccessSubscription = () => {
    history.push({
      pathname: "/edit-experience-taxes",
      state: { access: "edit" },
    });
  };

  const massCompletionToggle = (e) => {
    setState({
      ...state,
      massCompletion: !state.massCompletion,
    });
  };

  const onChangeMassCompletion = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const onCasualExperienceSubmitClick = () => {
    let values = {
      value:
        state.casualDiningOfflineExperience === false &&
          state.casualDiningOnlineExperience === false
          ? false
          : true,
      offline_experience: {
        value: state.casualDiningOfflineExperience,
      },
      // online_experience: {
      //   value: state.casualDiningOnlineExperience,
      // },
      massCompletion: {
        value: state.massCompletion,
        massCompletionTime: state.massCompletionTime,
      },
    };

    const token = props?.auth?.user?.accessToken;
    const subscriptionId = props?.subscription?._id;
    let formData = props?.allSubscriptionsData;
    formData = {
      ...formData,
      experience_management: {
        ...formData?.experience_management,
        offline_experience: {
          ...formData?.experience_management?.offline_experience,
        },
        massCompletion: {
          ...formData?.experience_management?.massCompletion,
        },
      },
    };
    // formData.experience_management = values;
    formData.experience_management.value = values?.value;
    formData.experience_management.offline_experience.value =
      values?.offline_experience.value;
    // formData.experience_management.online_experience.value =
    //   values?.online_experience.value;
    formData.experience_management.massCompletion.value =
      values?.massCompletion?.value;
    formData.experience_management.massCompletion.massCompletionTime =
      values?.massCompletion?.massCompletionTime;
    // console.log(subscriptionId, formData, token);

    let sendData = {
      ...props.subscription,
      experienceTaxesAndCharges: { ...props?.expTaxes, value: state.taxes }
    };
    if (props.subscription?.multi_service_business) {
      sendData.multi_service_business_status = formData;
    } else if (props.subscription?.fast_food_dining) {
      sendData.fast_food_dining_status = formData;
    } else {
      sendData.casual_dining_status = formData;
    }
    props.update_new_subscription_for_vendor(
      subscriptionId,
      sendData,
      token,
      onSuccess
    );
  };

  const onSuccess = (e) => {
    Alert.success("<h4>Experience subscription updated successfully..!</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    const formData = {
      casualDiningManagement: true,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
    history.push("/subscription");
  };

  useEffect(() => {
    setState({
      ...state,
      casualDiningOfflineExperience:
        props?.subscriptionData &&
          props?.subscriptionData?.offline_experience &&
          props?.subscriptionData?.offline_experience?.value !== undefined
          ? props?.subscriptionData &&
          props?.subscriptionData?.offline_experience &&
          props?.subscriptionData?.offline_experience?.value
          : false,
      casualDiningOnlineExperience:
        props?.subscriptionData &&
          props?.subscriptionData?.online_experience &&
          props?.subscriptionData?.online_experience?.value !== undefined
          ? props?.subscriptionData &&
          props?.subscriptionData?.online_experience &&
          props?.subscriptionData?.online_experience?.value
          : false,
      massCompletion:
        props?.subscriptionData?.massCompletion?.value !== null &&
          props?.subscriptionData?.massCompletion?.value !== undefined
          ? props?.subscriptionData?.massCompletion?.value
          : false,
      massCompletionTime:
        props?.subscriptionData?.massCompletion?.massCompletionTime !== null &&
          props?.subscriptionData?.massCompletion?.massCompletionTime !==
          undefined
          ? props?.subscriptionData?.massCompletion?.massCompletionTime
          : "",
      taxes: props?.expTaxes?.value || false
    });
  }, [props?.subscriptionData, props?.expTaxes]);

  const backButtonHandler = (e) => {
    e.preventDefault();
    const formData = {
      casualDiningManagement: true,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
    history.push("/subscription");
  };

  if (props?.auth?.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        {props?.auth?.user?.VendorUser?.have_vendor_submitted_details ? (
          <div className="container-fluid">
            <Row>
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
              <div className="right-side-panel">
                <RightSideNavigation
                  leftText="vendorReview"
                  actionPerform="button"
                  backButtonLink={() => history.goBack()}
                  displayText="Back"
                />
                <Col
                  lg={12}
                  className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 new-subscription-onboarding-component"
                >
                  <div className="inside-subscription-event-section">
                    <InnerComponent
                      state={state}
                      onClickCasualOfflineExperience={
                        onClickCasualOfflineExperience
                      }
                      disabled={disabled}
                      massCompletionToggle={massCompletionToggle}
                      onChangeMassCompletion={onChangeMassCompletion}
                      backButtonHandler={backButtonHandler}
                      onCasualExperienceSubmitClick={
                        onCasualExperienceSubmitClick
                      }
                      onExpTaxes={onExpTaxes}
                      onClickCasualOnlineEexperience={
                        onClickCasualOnlineEexperience
                      }
                      expTaxes={props.expTaxes}
                      history={history}
                      onClickRedirectToOtherScreen={onClickRedirectToOtherScreen}
                    />
                  </div>
                </Col>
              </div>
            </Row>
          </div>
        ) : (
          <div className="container-fluid">
            <div className="row">
              <div
                id="onboarding-scrollbar"
                className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
              >
                <Media query="(min-width: 992px)">
                  <div className="col-12">
                    <BackLogoIconButton
                      displayBackText={true}
                      displayArrow={true}
                      workWithLinkORClick={true}
                      notDisplaProgressBar={true}
                      backButtonClicked={(e) => backButtonHandler(e)}
                    />
                  </div>
                </Media>

                <Media query="(max-width: 991px)">
                  <MobileTopHeader
                    link={false}
                    onClick={(e) => backButtonHandler(e)}
                  />
                </Media>
                <div className="onboarding_process_screen-button-map inside-subscription-event-section">
                  <InnerComponent
                    state={state}
                    onClickCasualOfflineExperience={
                      onClickCasualOfflineExperience
                    }
                    disabled={disabled}
                    massCompletionToggle={massCompletionToggle}
                    onChangeMassCompletion={onChangeMassCompletion}
                    backButtonHandler={backButtonHandler}
                    onCasualExperienceSubmitClick={
                      onCasualExperienceSubmitClick
                    }
                    onClickCasualOnlineEexperience={
                      onClickCasualOnlineEexperience
                    }
                  />
                </div>
              </div>
              <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
                <SliderReusableComponent
                  // displayBarButton={true}
                  displayHamburger={true}
                  paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  bottomImage={require("../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-02.svg")}
                />
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
};

ExperienceManagementScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  auth: state?.auth,
  subscription:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
  subscriptionData: state?.onboarding?.onboard_subscription_details
    ?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
      ?.multi_service_business_status?.experience_management
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining
      ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
        ?.experience_management
      : state?.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.experience_management,
  allSubscriptionsData: state?.onboarding?.onboard_subscription_details
    ?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
      ?.multi_service_business_status
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining
      ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
      : state?.onboarding?.onboard_subscription_details?.casual_dining_status,
  expTaxes: state?.onboarding?.onboard_subscription_details?.experienceTaxesAndCharges
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
})(withRouter(ExperienceManagementScreen));

const InnerComponent = ({
  state,
  onClickCasualOfflineExperience,
  onClickCasualOnlineEexperience,
  disabled,
  massCompletionToggle,
  onChangeMassCompletion,
  backButtonHandler,
  onCasualExperienceSubmitClick,
  onClickRedirectToOtherScreen,
  onExpTaxes,
  expTaxes,
}) => {
  const history = useHistory();
  return (
    <React.Fragment>
      <TopTextReusableComponent headingText="Experience Management" />
      <div className="col-12 p-0">
        <div className="f16-700 my-4">Activate Experience Types</div>
        <ToggleButtonReuseTwo
          mainText="Offline Experience"
          paragraphText="(Note: Experiences are in a physical venue)"
          checkedBox={state.casualDiningOfflineExperience}
          onChange={onClickCasualOfflineExperience}
          disabled={disabled}
          editButtons={state.casualDiningOfflineExperience}
        />
        <hr className="mt-5 mb-5" />
        <ToggleButtonReuseTwo
          mainText="Online Experience"
          paragraphText="(Note: Experience are online you need a link stored at the time Event creation You can accept RSVP for the event)"
          checkedBox={state.casualDiningOnlineExperience}
          onChange={onClickCasualOnlineEexperience}
          disabled={true}
          fullyDisabled={true}
          editButtons={state.casualDiningOnlineExperience}
        />
        <hr className="mt-5 mb-5" />
        <div className="row align-items-center pb-4 ml-1">
          <div className="col-4 col-md-7 col-lg-6 p-0">
            <div className="f14-700">Experience Taxes Settings*</div>
          </div>
          <div className="col-4 col-md-2 col-lg-3">
            <ToggleButtonWithYesNo
              activeClass={state.taxes}
              checkedBox={state.taxes}
              onChange={onExpTaxes}
              disabled={disabled}
              extraClass="d-flex align-items-center"
              extraYesNo="f12-500"
            />
          </div>
          {/* <Media query="(min-width:991px)"> */}
          <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
            <div className="d-flex rightside-toggle-buttons-subscription-menu">
              <Button
                variant="link"
                className="enIconBtn mr-3"
                onClick={(e) => {
                  history.push({
                    pathname:
                      "/edit-experience-taxes",
                    state: { access: "view" },
                  });
                }}
              >
                <Image
                  src={require("../../../../../../../assets/images/UserManagement/eye.svg")}
                  alt="View"
                  title="View"
                  fluid
                />
              </Button>
              <Button
                variant="link"
                className="enIconBtn mr-3"
                onClick={onClickRedirectToOtherScreen}
              >
                <Image
                  src={require("../../../../../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </Button>
            </div>
          </div>
          {/* </Media> */}
        </div>
        <MassCompletion
          MassCompletionToggle={(e) => massCompletionToggle()}
          massCompletionValue={state.massCompletion}
          handleChange={(e) => onChangeMassCompletion(e)}
          massCompletionTime={state.massCompletionTime}
        />
      </div>
      <div className="onboarding-map-setup-screen-autodetect-button mt-5">
        <ReusableOnboardingButton
          buttonTitle="Back Button"
          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
          buttonText="Back"
          buttonType="button"
          onClick={(e) => backButtonHandler(e)}
        />
        {!disabled && (
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            buttonText="Done"
            buttonType="button"
            onClick={onCasualExperienceSubmitClick}
            disabled={disabled}
          />
        )}
      </div>
    </React.Fragment>
  );
};
